import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

const TONES = {
  tint: 'bg-tint text-accent-text',
  surface: 'bg-surface-2 text-text-1',
  outline: 'border border-border-token bg-surface text-text-1',
};

interface Props {
  label: ReactNode;
  tone?: keyof typeof TONES;
  removeLabel?: string;
  onRemove?: () => void;
  onClick?: () => void;
}

export const FilterChip: FC<Props> = ({ label, tone = 'tint', removeLabel = 'Remove', onRemove, onClick }) => {
  const body = (
    <>
      {label}
      {onRemove && (
        <button
          type="button"
          aria-label={removeLabel}
          className="inline-flex opacity-75 hover:opacity-100"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 6 18 18M18 6 6 18" />
          </svg>
        </button>
      )}
    </>
  );

  const className = classNames(
    'inline-flex items-center gap-[7px] h-7 rounded-full font-bold',
    TONES[tone],
    onClick && 'cursor-pointer hover:bg-tint'
  );
  const style = { fontSize: 12, padding: onRemove ? '0 8px 0 11px' : '0 11px' };

  if (onClick && !onRemove) {
    return (
      <button type="button" onClick={onClick} className={className} style={style}>
        {body}
      </button>
    );
  }
  return (
    <span className={className} style={style}>
      {body}
    </span>
  );
};
